<template>
  <div>

        <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; width: 100%;">
            <div style="display: flex; flex-direction: row; width: 100%; justify-content: space-between; align-items: space-between;">
                
                <el-input @focus="$event.target.select()"
                    placeholder="Search..."
                    size="small"
                    clearable
                    style="width: 250px; text-align: left;"
                    v-model="search_term">
                </el-input>
                
                <div style=" width: 40%; text-align: right; margin-top: 17px;">
                    <el-dropdown 
                        @command="openTaskForm">
                        <el-button size="small" type="primary" >
                            Add Task <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown" align="left">
                            <el-dropdown-item :command="'single_task'">Single Task</el-dropdown-item>
                            <el-dropdown-item :command="'group_task'">Group Task</el-dropdown-item>                            
                        </el-dropdown-menu>
                    </el-dropdown>
                    <!--<el-button @click="newTask" type="primary" size="small">Add Task</el-button>-->
                </div>
                
            </div>
            <div style="display: flex; flex-direction: row; flex-wrap: wrap;">
                <el-tag style="margin-right: 10px; cursor: pointer;" :type="getSelectedCategoryId === -1 ? 'success' : ''" @click="selected_category_id = -1">
                    All Categories ({{getDataList.length}})
                </el-tag>
                <el-tag
                    v-for="(data, index) in $store.getters.getTaskCategoryList"
                    :key="index"
                    :type="getSelectedCategoryId === data.id ? 'success' : ''"
                    v-if="getDataList.filter(t => t.category_id === data.id).length>0"
                    style="margin-right: 10px; cursor: pointer;"
                    @click="selected_category_id = data.id">
                    {{data.category_name}} ({{getDataList.filter(t => t.category_id === data.id).length}})
                </el-tag>
            </div>
            <div style="display: flex; flex-direction: row; flex-wrap: wrap; margin-top: 20px;">
                <el-tag style="margin-right: 10px; cursor: pointer;" :type="getSelectedPriority === -1 ? 'success' : ''" @click="selected_priority = -1">
                    All Priority ({{getDataList.length}})
                </el-tag>
                <el-tag
                    :type="getSelectedPriority === 0 ? 'success' : 'info'"
                    v-if="getDataList.filter(t => t.priority === 0).length>0"
                    style="margin-right: 10px; cursor: pointer;"
                    @click="selected_priority = 0">
                    Normal ({{getDataList.filter(t => t.priority === 0).length}})
                </el-tag>
                <el-tag
                    :type="getSelectedPriority === 1 ? 'success' : 'warning'"
                    v-if="getDataList.filter(t => t.priority === 1).length>0"
                    style="margin-right: 10px; cursor: pointer;"
                    @click="selected_priority = 1">
                    Medium ({{getDataList.filter(t => t.priority === 1).length}})
                </el-tag>
                <el-tag
                    :type="getSelectedPriority === 2 ? 'success' : 'danger'"
                    v-if="getDataList.filter(t => t.priority === 2).length>0"
                    style="margin-right: 10px; cursor: pointer;"
                    @click="selected_priority = 2">
                    Urgent ({{getDataList.filter(t => t.priority === 2).length}})
                </el-tag>
            </div>
            <div style="display: flex; flex-direction: row; flex-wrap: wrap; margin-top: 20px;">
                <el-tag style="margin-right: 10px; cursor: pointer;" :type="getSelectedStatus === -1 ? 'success' : ''" @click="selected_status = -1">
                    All Status ({{getDataList.length}})
                </el-tag>
                <el-tag
                    :type="getSelectedStatus === 0 ? 'success' : 'info'"
                    v-if="getDataList.filter(t => t.status === 0).length>0"
                    style="margin-right: 10px; cursor: pointer;"
                    @click="selected_status = 0">
                    New ({{getDataList.filter(t => t.status === 0).length}})
                </el-tag>
                <el-tag
                    :type="getSelectedStatus === 1 ? 'success' : 'warning'"
                    v-if="getDataList.filter(t => t.status === 1).length>0"
                    style="margin-right: 10px; cursor: pointer;"
                    @click="selected_status = 1">
                    WIP ({{getDataList.filter(t => t.status === 1).length}})
                </el-tag>
                <el-tag
                    :type="getSelectedStatus === 2 ? 'success' : 'danger'"
                    v-if="getDataList.filter(t => t.status === 2).length>0"
                    style="margin-right: 10px; cursor: pointer;"
                    @click="selected_status = 2">
                    Completed ({{getDataList.filter(t => t.status === 2).length}})
                </el-tag>
                <el-tag
                    :type="getSelectedStatus === 3 ? 'success' : 'danger'"
                    v-if="getDataList.filter(t => t.status === 3).length>0"
                    style="margin-right: 10px; cursor: pointer;"
                    @click="selected_status = 3">
                    Rejected ({{getDataList.filter(t => t.status === 3).length}})
                </el-tag>
            </div>
            <div style="width: 100%; margin-top: 20px;">
                <List :dataList="getDisplayList"/>
            </div>
          
        </div>
      
    <el-dialog
        v-if="$store.state.tasks.show_task_form"
        :fullscreen="isMobileDevice"
        :title="$store.getters.getTaskDataProps.id>0 ? $store.getters.getTaskDataProps.title : 'New Task'"
        :width="isMobileDevice ? '100%' : '450px'"
        :visible.sync="$store.state.tasks.show_task_form"
        append-to-body>
            <TaskForm 
                @closed="loadList"/>
    </el-dialog>

    <el-dialog
        v-if="$store.state.tasks.show_task_group_form"
        :title="'New Group Task'"
        width="90%"
        :visible.sync="$store.state.tasks.show_task_group_form"
        append-to-body>
            <GroupTask 
                @closed="loadList"/>
    </el-dialog>

  </div>
</template>

<script>
//import TaskListDisplay from './TaskListDisplay'
import TaskForm from './TaskForm'
import GroupTask from './GroupTask'
import List from './List.vue'
import { isMobile } from 'mobile-device-detect';

export default {
    data() {
        return {
            search_term: '',
            selected_category_id: -1,
            selected_priority: -1,
            selected_status: -1
        }
    },
    computed: { 
        isMobileDevice() {
            return isMobile
        },
        getSelectedCategoryId() {
            return this.selected_category_id  
        },
        getSelectedPriority() {
            return this.selected_priority  
        },
        getSelectedStatus() {
            return this.selected_status  
        },
        getDataList() {
            let search_term = this.search_term.toLowerCase()
            
            return this.$store.getters.getTaskList
                .filter(t => (t.title.toLowerCase().match(search_term) || t.assigned_to_alias_name.toLowerCase().match(search_term) || t.created_by_alias_name.toLowerCase().match(search_term) || t.assigned_to_name.toLowerCase().match(search_term) || t.created_by_name.toLowerCase().match(search_term)))
        },
        getDisplayList() {
            let list = this.getSelectedCategoryId>=0 ? this.getDataList.filter(t => t.category_id === this.getSelectedCategoryId) : this.getDataList
            list = this.getSelectedPriority>=0 ? list.filter(t => t.priority === this.getSelectedPriority) : list
            list = this.getSelectedStatus>=0 ? list.filter(t => t.status === this.getSelectedStatus) : list

            return list
        }
    },
    components: { List, TaskForm, GroupTask },
    methods: {
        loadList() {
            this.$store.dispatch('fetchTaskList')
        },
        newTask() {
            this.$store.commit('resetTaskData')
            this.$store.commit('resetTaskGroupData')
            this.$store.state.tasks.show_task_form = true
        },
        openTaskForm(command) {
            if(command == 'single_task') {
                this.newTask()
            } else if(command == 'group_task') {
                this.$store.commit('resetTaskData')
                this.$store.commit('resetTaskGroupData')
                this.$store.state.tasks.show_task_group_form = true
            }
        }
    },
    mounted() {
        this.$store.state.tasks.show_task_form = false
        this.$store.dispatch('fetchTaskCategoryList')
        this.$store.dispatch('fetchEmployeeMasterList', {store_list: this.$store.getters.getAccessibleStoreList})
        this.loadList()
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Tasks/Index.vue